.wrapper {
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  height: 4rem;
  padding: 0 2rem;
  background-color: var(--white);
}

.subtitleWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background-color: var(--white);
  padding: 2rem;
}

.subtitle {
  color: var(--gray-dark);
  font-family: 'Aeroport';
  font-size: 1rem;
}

.inputWrapper {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: var(--gray-light);
  border-radius: 10px;
  padding-left: 1rem;
  width: 216px;
}

.inputIcon {
  color: var(--text-dark);
  z-index: 1;
}

.loader {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  min-height: 4rem;
  max-height: 4rem;
}

.tableWrapper {
  background-color: var(--white);
  padding: 0 0 2rem 0;
  border-radius: 0 0 8px 8px;
  font-family: 'Aeroport';
}

.tableHeader {
  display: flex;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 36px 3.5rem 72px 3.5rem;
}

.table {
  display: flex;
  flex-direction: column;
  background-color: var(--white);
}

.row {
  border-bottom: 1px solid var(--gray);
  margin-bottom: 0 !important;
}

/* .row:last-child {
  border-bottom: none;
}

.row:only-child {
  border-bottom: none;
} */

.rowLevel {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 1.9rem 3.5rem 0.9rem 3.5rem;
}

.rowLevelInner {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 0 0 0;
}

.rowLevelInner > .rowLeft {
  width: 50%;
  max-width: 500px;
}

.rowLeft {
  display: flex;
  align-items: center;
  flex: 1.3;
}

.rowRight {
  display: flex;
  align-items: center;
  flex: 1;
}

.rowItem {
  display: flex;
  align-items: center;
  flex: 1;
}

.rowMenu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  gap: 12px;
}

.rowBorder {
  display: flex;
  position: absolute;
  width: 4px;
  height: 100%;
  background: linear-gradient(
    180deg,
    var(--primary-gradient1) -18.54%,
    var(--primary-gradient2) 99.84%
  );
}

.rowLevelWrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 0 2rem 3.5rem;
}

@media screen and (max-width: 768px) {
  .rowLevel,
  .rowLeft,
  .rowRight {
    flex-direction: column;
    align-items: flex-start;
  }
}

.textMuted {
  color: var(--gray-darker);
  font-size: 15px;
}

.label {
  font-weight: 500;
}

.tags {
  display: flex;
}

.modalBodyText {
  font-size: 16px;
}

.edit {
  color: var(--gray-dark);
}

.delete {
  color: var(--danger);
}

.paddingBottom {
  padding-bottom: 1rem;
}
